<template>
  <div class="csgo-mask index-win-box flex flex-jc flex-ac">
    <div class="win">
      <div class="win-top">
        <div class="win-title">{{ winStatus == 1 ? '恭喜你' : winStatus == 2 ? '升级成功' : '升级失败' }}</div>
        <img v-if="winStatus==3" src="@/assets/images/win2.png" />
        <img v-else src="@/assets/images/win1.png" />
      </div>
      <div class="win-con" :class="'win-con'+winList.length">
        <ul>
          <li v-for="(item, index) in winList" :key="index" class="skin-li" :class="parseColor(item)">
            <div class="li-div">
              <div class="bei">
                <img :src="item.img" class="img_active" />
              </div>
              <div class="name p-2">{{ item.name ? item.name : item.skin_name }}</div>
              <div class="flex flex-ac flex-jsb" style="padding-bottom: 7.5px;">
                <div class="money-warp">
                  <img src="@/assets/images/money.png" class="money-img" />
                  <span>{{ item.price }}</span>
                </div>
                <div v-if="winStatus != 3" class="plus-ass win-span1" :data-index="index" @click="winexchange(index)">分解</div>
              </div>
              <!-- <div class="color-line" :style="'background-color:'+parseColor(item,'price','color')"></div> -->
              <!-- <div class="win-content">
                <div class="win-text" :title="item.name">{{ item.name?item.name:item.skin_name }}</div>
              </div> -->
            </div>
          </li>
        </ul>
      </div>
      <div class="win-bot flex">
        <div v-if="winStatus != 3" class="win-span1 flex-1" @click="winexchange(-1)">全部分解</div>
        <div v-if="winStatus == 1" class="win-span1 win-span2 flex-1" @click="winget">再来一次</div>
        <!-- <div class="win-span2" @click="winget">放入背包</div> -->
      </div>
      <div class="win-x" @click="winX">
        <i class="el-icon-circle-close"></i>
      </div>
      <div class="win-back">
        <img src="../assets/images/win3.png" />
      </div>
    </div>
  </div>

</template>

<script>
import { parseColor } from "@/assets/js/util.js";
export default {
  // winStatus 1 表示箱子开箱  2 升级成功  3 升级失败
  props: ["winList", "winState", "player_skins_ids", 'winStatus'],
  data() {
    return {
      list4: [],
      parseColor,
      total_price: 0,
    };
  },
  methods: {
    //兑换
    winexchange(index) {
      let player_skins_ids = this.winList.map(v => v.player_skins_id);
      if (index != -1) {
        let obj = document.querySelector(".win-span1[data-index='" + index + "']");
        if (obj.classList.contains('disabled') == true) {
          console.log('disabled');
          return;
        }
        player_skins_ids = [this.winList[index].player_skins_id]
      }
      console.log(this.winList)
      let param = {
        player_skins_ids: player_skins_ids,
      }
      this.$doPost("/api/member.SkinBackpack/exchangeToMoney", param).then((res) => {
        this.$store.commit("getAboutMon", res.data)
        this.$message({
          showClose: true,
          message: res.msg,
          type: "success",
        });
        if (index != -1) {
          document.querySelector(".win-span1[data-index='" + index + "']").classList.add('disabled');
          document.querySelector(".win-span1[data-index='" + index + "']").innerHTML = '已分解';
        } else {
          this.$emit("winexchange", false);
        }
      }).catch((err) => { })
      // this.$confirm('确定分解选中的饰品？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //
      // }).catch(() => { })
    },
    //放入背包
    winget() {
      this.$emit("winget", false);
    },
    //x掉
    winX() {
      this.$emit("winX", false);
    },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.win {
  width: 600px;
  // max-height: 100vh;
  // overflow-y: auto;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.4);
  position: relative;
  border-radius: 10px;
  .win-back {
    width: 100%;
    height: auto;
    position: absolute;
    top: 0%;
    left: 0;
    z-index: -10;
    animation: move 5s linear infinite;

    img {
      width: 100%;
      height: auto;
    }
  }
  @keyframes move {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .win-top {
    width: 100%;
    position: relative;
    text-align: center;
    .win-title {
      position: absolute;
      font-size: 36px;
      font-weight: bold;
      color: #000;
      transform: translate(-50%, 0);
      line-height: 74px;
      bottom: 45px;
      left: 50%;
    }
    img {
      // width: 80%;
      height: 200px;
    }
  }
  .win-x {
    position: absolute;
    top: 0px;
    right: 0px;
    color: #e9b10e;
    text-align: center;
    padding: 10px;
    font-size: 30px;
    cursor: pointer;
  }
  .win-bot {
    margin-top: 10px;
    .win-span1 {
      padding: 10px 0;
      background: #ff9a00;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      cursor: pointer;
      color: #fff;
      &.win-span2 {
        background: #00f7ff;
        margin-left: 10px;
      }
    }
  }
  .win-con {
    ul {
      display: flex;
      justify-content: center;
      .skin-li {
        width: 80%;
        padding: 15px;
        box-sizing: border-box;
        overflow: hidden;
        .li-div {
          background: #000000;
          border-radius: 8px;
          overflow: hidden;
          color: #fff;
          position: relative;
          padding: 0px 10px 0;
          box-sizing: border-box;
          .bei {
            max-width: 195px;
            // aspect-ratio: 1 / 1;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            .img_active {
              height: 60px;
              width: auto;
              // max-width: 100%;
            }
          }
          .name {
            line-height: 24px;
            height: 48px;
          }
          .money-warp {
            color: #ffc400;
            display: flex;
            align-items: center;
          }
          .color-line {
            width: 70%;
            height: 6px;
            border-radius: 3px;
            // margin: 20px auto 0;
          }
          .plus-ass {
            width: 50px;
            font-size: 12px;
            font-weight: 100;
            background: #ff9a00;
            border-radius: 6px;
            text-align: center;
            line-height: 24px;
            cursor: pointer;
          }
        }
        .li-div-center {
          text-align: center;
          .money-warp {
            justify-content: center;
          }
        }
        &.darkBlue-skin {
          .li-div .bei {
            background: #000000 url(~@/assets/images/skin/dark_blue.png) no-repeat;
            background-size: auto 100%;
            background-position: center center;
          }
        }
        &.babyBlue-skin {
          .li-div .bei {
            background: #000000 url(~@/assets/images/skin/baby_blue.png) no-repeat;
            background-size: auto 100%;
            background-position: center center;
          }
        }
        &.yellow-skin {
          .li-div .bei {
            background: #000000 url(~@/assets/images/skin/yellow.png) no-repeat;
            background-size: auto 100%;
            background-position: center center;
          }
        }
        &.red-skin {
          .li-div .bei {
            background: #000000 url(~@/assets/images/skin/red.png) no-repeat;
            background-size: auto 100%;
            background-position: center center;
          }
        }
        &.lavender-skin {
          .li-div .bei {
            background: #000000 url(~@/assets/images/skin/lavender.png) no-repeat;
            background-size: auto 100%;
            background-position: center center;
          }
        }
        &.eggplant-skin {
          .li-div .bei {
            background: #000000 url(~@/assets/images/skin/eggplant.png) no-repeat;
            background-size: auto 100%;
            background-position: center center;
          }
        }
        &.gray-skin {
          .li-div .bei {
            background: #000000 url(~@/assets/images/skin/gray.png) no-repeat;
            background-size: auto 100%;
            background-position: center center;
          }
        }
      }
    }
  }
  .win-con1 {
    ul {
      width: 80%;
      margin: 0 auto;
      .skin-li {
        width: 80%;
      }
    }
  }
  .win-con2 {
    ul {
      width: 100%;
      .skin-li {
        width: 50%;
      }
    }
  }

  .win-con3 {
    ul {
      .skin-li {
        width: 33.33%;
        padding: 7.5px;
      }
    }
  }

  .win-con4 {
    ul {
      flex-wrap: wrap;
      .skin-li {
        width: calc(50% - 10px);
      }
    }
  }

  .win-con5 {
    ul {
      flex-wrap: wrap;
      width: 100%;
      .skin-li {
        width: calc(33.33% - 7.5px);
        padding: 7.5px;
        .win-warp {
          .win-content {
            padding: 5px;
          }
        }
        &:nth-child(1) {
          width: 35%;
          margin-left: 10%;
        }
        &:nth-child(2) {
          width: 35%;
        }
      }
    }
  }

  .win-span1.disabled {
    background-color: gainsboro !important;
  }
}
</style>
